import React from 'react';
import QSHub from '../../components/qs/QSHub';

export default function SafetyIntelligence() {
  return <QSHub domain="SAFETY" />;
}
